import axios, { AxiosResponse } from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { HierarchyQueryParams } from "./HierarchyQueryParams";
import { HierarchyReadDto } from "./HierarchyReadDto";

export type HierarchyReadDtoDataReturn = IAxiosReturn<HierarchyReadDto>;

/**
 * Load a hierarchy by name or id.
 *
 * @param backEndUrl - Base backend URL
 * @param hierarchyQuery - Query parameters to identify the hierarchy
 * @param controller - Optional AbortController
 * @returns The hierarchy wrapped in HierarchyReadDtoDataReturn
 */
export const loadHierarchy = async (
  backEndUrl: string,
  hierarchyQuery: HierarchyQueryParams,
  controller?: AbortController,
): Promise<HierarchyReadDtoDataReturn> => {
  let url = hierarchyQuery.hierarchyName
    ? `${backEndUrl}Hierarchy/Name/${hierarchyQuery.hierarchyName}`
    : `${backEndUrl}Hierarchy/Id/${hierarchyQuery.hierarchyId}`;
  if (hierarchyQuery.parentTag) {
    url += `?parentTag=${hierarchyQuery.parentTag}`;
  }
  // Get data
  try {
    const response: AxiosResponse = await axios.get(
      url,
      controller !== undefined ? { signal: controller.signal } : undefined,
    );

    // Return successful result
    return {
      success: true,
      data: response.data,
    };
  } catch (error: unknown) {
    return processAxiosError("Load hierarchy failed", error);
  }
};
